import React from "react";
import { Link } from "react-router-dom";
import { PG_BRAND, PG_LEGAL, PG_PHONE, PG_PHONE_TEL, PG_EMAIL, PG_LOCATION } from "../lib/api";

export default function SiteFooter() {
  return (
    <footer className="bg-[#0A1128] text-[#F8FAFC]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-4">
            <span className="h-8 w-8 rounded-sm bg-[#D4AF37] text-[#0A1128] inline-flex items-center justify-center font-display font-bold">
              P
            </span>
            <span className="font-display text-lg font-semibold tracking-[0.18em]">{PG_BRAND}</span>
          </div>
          <p className="text-sm text-[#94A3B8] leading-relaxed max-w-sm">
            {PG_LEGAL} — a premium, fully insured cleaning service for homes, offices, and commercial
            spaces across all five NYC boroughs.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-[#CBD5E1]">
            <li>
              <a href={`tel:${PG_PHONE_TEL}`} data-testid="footer-phone" className="hover:text-[#D4AF37]">
                {PG_PHONE}
              </a>
            </li>
            <li>
              <a href={`mailto:${PG_EMAIL}`} data-testid="footer-email" className="hover:text-[#D4AF37]">
                {PG_EMAIL}
              </a>
            </li>
            <li>{PG_LOCATION}</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-3">Notices</div>
          <ul className="text-xs text-[#94A3B8] space-y-2 leading-relaxed">
            <li>Final price may change based on actual condition, mold, grease, and complexity.</li>
            <li>Large & biohazard jobs require manual quote approval.</li>
            <li>Disposal fees may apply for junk removal.</li>
            <li>Same-day, after-hours, and holiday bookings may include surcharges.</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1E293B]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#64748B]">
          <span>© {new Date().getFullYear()} {PG_LEGAL}. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#D4AF37]">
            Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
